'use strict';

/**
 * Event triggered when customer click on a colored shade
 */
$('.landing-rouge-shade-interact-module-shade-svg path, .landing-rouge-shade-interact-aria, .aqua-resist-shade-selector-button').on('click', function(){

    if(!($(this).hasClass('active'))){
        var landingShadeID = $(this).attr('data-shadeid');
        var landingShadeColor = $(this).attr('data-background');
        var landingShadeContrastColor = $(this).attr('data-contrast') || '#ffffff';
        var landingShadeName = $(this).attr('data-shadename');
        var landingShadeImage = $(this).attr('data-src');
        var landingShadeImageMobile = $(this).attr('data-src-mobile');
        var landingPackshot = $(this).attr('data-packshot');
        var landingPackshotMobile = $(this).attr('data-packshot-mobile');

        $(".landing-rouge-shade-interact-module-shade-svg path").removeClass('active');
        $(".aqua-resist-shade-selector-button").removeClass('active').attr('aria-checked','false');
        $(this).addClass('active').attr('aria-checked','true');

        $('.landing-rouge-shade-interact-module-shade-groupname').removeClass('active');
        $(this).closest('.landing-rouge-shade-interact-module-shade-svgcontainer').find('.landing-rouge-shade-interact-module-shade-groupname').addClass('active');

        if(landingShadeColor){
            $('.landing-rouge-shade-interact-content').css( "background-color", landingShadeColor);
            $('.landing-rouge-shade-interact-module-product-container').css({ "background-color": landingShadeColor, 'color': landingShadeContrastColor });
            $('.landing-rouge-shade-interact-module-product-content-mobile').css( "background-color", landingShadeColor);
        }
        if(landingShadeID){
            $('.landing-rouge-shade-interact-module-product-title').empty().html("#"+ landingShadeID);
            var urldefaultShade = $('.rouge-artist-vto-url').attr("data-url");
            var shadeUrl = urldefaultShade + "?shadeid=" + landingShadeID;
            $('.landing-rouge-shade-interact-module-product-container .landing-rouge-shade-interact-btn.btn').attr("href", shadeUrl);
        }
        if(landingShadeName){
            $('.landing-rouge-shade-interact-module-product-subtitle').empty().html(landingShadeName);
        }

        $('.landing-rouge-shade-interact-module-product-img').attr('src',landingShadeImage);
        $('.landing-rouge-shade-interact-module-product-img-mobile').attr('src',landingShadeImage);
        if(landingShadeImageMobile){
            $('.landing-rouge-shade-interact-module-product-img-mobile-vertical').attr('src',landingShadeImageMobile);
        }

        if(landingPackshot){
            $('.landing-rouge-shade-interact-module-product-content .landing-rouge-shade-interact-module-product-img-packshot').attr('src',landingPackshot);
        }
        if(landingPackshotMobile){
            $('.landing-rouge-shade-interact-module-product-content-mobile .landing-rouge-shade-interact-module-product-img-packshot').attr('src',landingPackshotMobile);
        }
        
    }
});

$(document).ready( function(){
    $('#landing-rouge-artist-container').show();
});

